
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface EventImageSquareProps {
  image?: string | null;
  title: string;
  onClick?: () => void;
  className?: string;
  eventImages?: Array<{
    image_id: string;
    image_url: string;
    is_primary: boolean;
    display_order: number;
  }> | null;
}

export const EventImageSquare = ({ 
  image, 
  title, 
  onClick, 
  className = "",
  eventImages
}: EventImageSquareProps) => {
  // Determine which image URL to use
  // 1. First check for primary image in eventImages
  // 2. Fall back to the first image in eventImages
  // 3. Finally fall back to the legacy image prop
  let imageUrl = image;
  
  if (eventImages && eventImages.length > 0) {
    // Look for primary image first
    const primaryImage = eventImages.find(img => img.is_primary);
    
    if (primaryImage) {
      imageUrl = primaryImage.image_url;
    } else {
      // Sort by display_order and take the first
      const sortedImages = [...eventImages].sort((a, b) => a.display_order - b.display_order);
      imageUrl = sortedImages[0].image_url;
    }
  }

  return (
    <AspectRatio ratio={1} className={`w-full overflow-hidden ${className}`}>
      <div 
        className={`w-full h-full ${onClick ? 'cursor-pointer' : ''}`}
        style={imageUrl ? {
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        } : {
          background: 'linear-gradient(90deg, hsla(277, 75%, 84%, 1) 0%, hsla(297, 50%, 51%, 1) 100%)'
        }}
        aria-label={`Image for ${title}`}
        onClick={onClick}
      />
    </AspectRatio>
  );
};
